import { render, staticRenderFns } from "./PrivacyMain.vue?vue&type=template&id=864d8cc2&scoped=true&"
import script from "./PrivacyMain.vue?vue&type=script&lang=js&"
export * from "./PrivacyMain.vue?vue&type=script&lang=js&"
import style0 from "./PrivacyMain.vue?vue&type=style&index=0&id=864d8cc2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "864d8cc2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/ctweb/fontend/kecc/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('864d8cc2')) {
      api.createRecord('864d8cc2', component.options)
    } else {
      api.reload('864d8cc2', component.options)
    }
    module.hot.accept("./PrivacyMain.vue?vue&type=template&id=864d8cc2&scoped=true&", function () {
      api.rerender('864d8cc2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/DefaultHome/KECC/Declare/Privacy/PrivacyMain.vue"
export default component.exports